import { th } from 'style/theme';
import styled, { css } from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ReactComponent as NILogoSVG } from 'products/nomad_insurance/assets/img/ni-logo.svg';
import Modal from 'components/Modal';
import { H2 } from 'components/Typography';
import { ReactComponent as ModalWaveMobileSvg } from 'products/nomad_insurance/assets/img/waves/modal-wave-mobile.svg';
import { ReactComponent as ModalWaveSvg } from 'products/nomad_insurance/assets/img/waves/modal-wave.svg';
import { sizes } from 'style';

export const CustomModal = styled(Modal)`
  > button {
    display: none;
    background-color: transparent;
    box-shadow: none;
    margin: 20px;

    @media ${sizes.tabletLandscape} {
      display: block;
    }

    > svg {
      fill: ${th('colors.white')};
      height: 24px;
      width: 24px;
    }

    :hover {
      background-color: transparent;
    }
  }

  > div {
    padding: 0;
  }

  @media ${sizes.tabletLandscape} {
    border-radius: 24px;
  }
`;

export const MobileCloseButton = styled(FontAwesomeIcon)`
  position: absolute;
  top: 20px;
  left: 20px;

  @media ${sizes.tabletLandscape} {
    display: none;
  }
`;

export const Header = styled.div`
  height: 50px;
  background-color: ${th('colors.fountainBlue')};
  background-color: ${({ headerColor }) => th(`colors.${headerColor}`)};

  @media ${sizes.tabletLandscape} {
    border-radius: 24px 24px 0 0;
  }

  @media ${sizes.desktop} {
    height: 40px;
  }
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  border-radius: 32px;
  padding: 20px;

  @media ${sizes.tabletLandscape} {
    padding: 40px;
    padding-top: 0;
  }
`;

const modalHeaderStyle = css`
  fill: ${th('colors.fountainBlue')};
  fill: ${({ $headerColor }) => th(`colors.${$headerColor}`)};
  margin-top: -2px;
`;

export const ModalWave = styled(ModalWaveSvg)`
  ${modalHeaderStyle};
  display: none;

  @media ${sizes.tabletLandscape} {
    display: block;
  }
`;

export const ModalMobileWave = styled(ModalWaveMobileSvg)`
  ${modalHeaderStyle};

  display: block;

  @media ${sizes.tabletLandscape} {
    display: none;
  }
`;

export const Heading = styled(H2)`
  color: ${th('colors.pickledBluewood')};
  font-weight: 700;
  font-size: 24px;
  line-height: 32px;
`;

export const Logo = styled(NILogoSVG)`
  position: absolute;
  top: 20px;
  left: 50%;
  transform: translateX(-50%);

  z-index: 1;
`;
